<h2 mat-dialog-title>Application Updates</h2>

<mat-dialog-content>
    <div class="update-section">
        <h3>Update Status</h3>

        @if (!isEnabled) {
        <div class="warning-message">
            <mat-icon>warning</mat-icon>
            <span>Service Worker is not enabled. Updates cannot be checked.</span>
        </div>
        } @else {
        <div>
            <div class="status-row">
                <span>Update available:</span>
                <span class="status" [class.available]="isUpdateAvailable">
                    {{ isUpdateAvailable ? 'Yes' : 'No' }}
                </span>
            </div>

            @if (isUpdateAvailable) {
            <div class="update-info">
                <p>A new version of the application is available.</p>
                @if (versionInfo.currentHash !== 'Unknown') {
                <div class="hash-info">
                    <div>Current version: <code>{{ versionInfo.currentHash }}</code></div>
                    <div>New version: <code>{{ versionInfo.newHash }}</code></div>
                </div>
                }
            </div>
            }

            @if (updateError) {
            <div class="error-message">
                <mat-icon>error</mat-icon>
                <span>{{ updateError }}</span>
            </div>
            }

            <div class="action-buttons">
                <button mat-flat-button color="primary" [disabled]="isCheckingForUpdate" (click)="checkForUpdate()">
                    <mat-icon>refresh</mat-icon>
                    {{ isCheckingForUpdate ? 'Checking...' : 'Check for Updates' }}
                </button>

                <button mat-flat-button color="accent" [disabled]="!isUpdateAvailable" (click)="activateUpdate()">
                    <mat-icon>system_update</mat-icon>
                    Apply Update
                </button>
            </div>
        </div>
        }
    </div>

    <mat-divider class="section-divider"></mat-divider>

    <div class="platform-section">
        <h3>System Information</h3>

        <mat-card>
            <mat-card-content>
                <h4>Version Information</h4>
                <div class="info-grid">
                    @if (isEnabled) {
                    <div class="info-row">
                        <span class="info-label">Service Worker:</span>
                        <span class="info-value">{{ versionInfo.serviceWorkerEnabled ? 'Enabled' : 'Disabled'
                            }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Current Hash:</span>
                        <span class="info-value">{{ versionInfo.currentHash }}</span>
                    </div>
                    } @else {
                    <div class="info-row">
                        <span class="info-label">Service Worker:</span>
                        <span class="info-value">Disabled</span>
                    </div>
                    }
                </div>

                <h4>Platform Information</h4>
                <div class="info-grid">
                    <div class="info-row">
                        <span class="info-label">Browser:</span>
                        <span class="info-value">{{ platformInfo.isBrowser ? 'Yes' : 'No' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Operating System:</span>
                        <span class="info-value">
                            {{ platformInfo.isAndroid ? 'Android' :
                            platformInfo.isIOS ? 'iOS' :
                            platformInfo.isChrome ? 'Chrome' : 'Unknown' }}
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Browser Type:</span>
                        <span class="info-value">
                            {{ platformInfo.isChrome ? 'Chrome' :
                            platformInfo.isFirefox ? 'Firefox' :
                            platformInfo.isSafari ? 'Safari' :
                            platformInfo.isEdge ? 'Edge' :
                            platformInfo.isTrident ? 'Internet Explorer' : 'Unknown' }}
                        </span>
                    </div>

                </div>
            </mat-card-content>
        </mat-card>

        <div class="copy-section">
            <button mat-stroked-button color="primary" (click)="copyInfo()">
                <mat-icon>content_copy</mat-icon>
                Copy All Information
            </button>
            <p class="help-text">
                Copy this information to share with support when reporting issues.
            </p>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>